document.addEventListener('DOMContentLoaded', () => {
    const readMoreLink = document.querySelector('.collection-hero__read-more');
    const showLessLink = document.querySelector('.collection-hero__show-less');
    const shortDescription = document.querySelector('.collection-hero__description-short');
    const fullDescription = document.querySelector('.collection-hero__description-full');
  
    if (readMoreLink && showLessLink && shortDescription && fullDescription) {
      readMoreLink.addEventListener('click', (e) => {
        e.preventDefault();
        shortDescription.style.display = 'none';
        fullDescription.style.display = 'block';
      });
  
      showLessLink.addEventListener('click', (e) => {
        e.preventDefault();
        fullDescription.style.display = 'none';
        shortDescription.style.display = 'block';
      });
    }
  });